import { SCORING_PRIORITIES } from "../types/lead-priority";
import type { ScoringConfigRule } from "../types/scoring-config";

import { isScoringRuleAccountScoped } from "./isScoringRuleAccountScoped";

/** Account-scoped rule ids (empty teamIds), collected so team selection can exclude them. */
export const collectAccountScopedScoringRuleIds = (rules: ScoringConfigRule | undefined): ReadonlySet<string> =>
    new Set(
        SCORING_PRIORITIES.flatMap((priority) =>
            (rules?.[priority] ?? []).flatMap((rule) =>
                rule.id && isScoringRuleAccountScoped(rule.teamIds) ? [rule.id] : [],
            ),
        ),
    );
